import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import Gotlim from "./Gotlim";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Gotlim />
  </React.StrictMode>
);
